/**
 * Maps a hand-edited `{ startDate?, endDate? }` range update onto a pair of
 * search-param keys, keeping only the fields actually present in `range` (a
 * single-field Datepicker edit only carries that one key). Callers must
 * spread the result rather than always writing both keys, otherwise editing
 * one date wipes the other back to its fallback value.
 */
export const buildDateRangePatch = <
    TStartKey extends string,
    TEndKey extends string,
>(
    range: { startDate?: string; endDate?: string },
    keys: { start: TStartKey; end: TEndKey },
): Partial<Record<TStartKey | TEndKey, string | undefined>> => {
    const patch: Partial<Record<TStartKey | TEndKey, string | undefined>> = {};

    if ('startDate' in range) {
        patch[keys.start] = range.startDate;
    }
    if ('endDate' in range) {
        patch[keys.end] = range.endDate;
    }

    return patch;
};
